/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { inject, InjectionToken, Injector } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { initial } from 'lodash';
import { LazyRegistry } from './lazy-registry.service';

/**
 * Symbols exported by lazy module should be defined under this token
 */
export const LAZY_SYMBOLS = new InjectionToken<Hash<any>>('LazySymbols');

function getLazyModulePath(snapshot: ActivatedRouteSnapshot): string {
  return initial(snapshot.pathFromRoot).map((element) => element.url.toString()).join('/');
}

/**
 * Functional guard for <code>/@lazy-activator</code> route in the lazy module.
 * Exports all symbols from LAZY_SYMBOLS into the LazyRegistry.
 */
export const lazyActivatorGuard: CanActivateFn = (route: ActivatedRouteSnapshot): boolean => {
  const lazyRegistry = inject(LazyRegistry);
  const symbols = inject(LAZY_SYMBOLS);
  const injector = inject(Injector);
  const modulePath = getLazyModulePath(route);
  if (!lazyRegistry.isModuleLoaded(modulePath)) {
    lazyRegistry.add(modulePath, injector, symbols);
  }
  return false;
};
